/**
 * @flow
 */
import history from '../../history'

class Nav {

  constructor() {
    process.env.NODE_ENV !== 'production' && console.log('[Nav] initialized');
  }

  push(path: string) {
    history.push(path);
  }

  current() {
    return history.location.pathname;
  }

  is(path) {
    return this.current() === path;
  }

  addListener(callback) {
    history.listen(callback);
  }

}

export default new Nav();
